import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useProjectionMode = () => {
  const [searchParams] = useSearchParams();

  const selectedProjectionLanguage = useMemo(() => {
    const param = searchParams.get('selectedProjectionLanguage');
    if (!param) return [];

    try {
      return JSON.parse(decodeURIComponent(param)) as string[];
    } catch {
      return [];
    }
  }, [searchParams]);

  const setSelectedProjectionLanguage = (languages?: string[]) => {
    const newParams = new URLSearchParams(window.location.search);

    if (languages && languages.length > 0) {
      newParams.set('selectedProjectionLanguage', JSON.stringify(languages));
    } else {
      newParams.delete('selectedProjectionLanguage');
    }

    const newUrl = `${window.location.pathname}?${newParams.toString()}`;
    window.open(newUrl, '_blank');
  };

  const isProjectionMode = useMemo(() => {
    return selectedProjectionLanguage.length > 0;
  }, [selectedProjectionLanguage]);

  return {
    selectedProjectionLanguage,
    setSelectedProjectionLanguage,
    isProjectionMode,
  };
};
